import { render, staticRenderFns } from "./AuthorSectionEditor.vue?vue&type=template&id=0492604a"
import script from "./AuthorSectionEditor.vue?vue&type=script&lang=ts"
export * from "./AuthorSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./AuthorSectionEditor.vue?vue&type=style&index=0&id=0492604a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports